import React from 'react'
import { Link, LinkProps, useNavigate } from 'react-router'

import { cn } from '@/lib/utils'

export type ActionLinkProps = LinkProps &
  React.RefAttributes<HTMLAnchorElement> & {
    beforeNavigate?: (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => void
    afterNavigate?: (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => void
    disabled?: boolean
  }

// Use when you want to run some code before navigating to a new route.
const ActionLink: React.FC<ActionLinkProps> = ({
  to,
  replace,
  beforeNavigate,
  afterNavigate,
  disabled = false,
  className,
  ...props
}) => {
  const navigate = useNavigate()

  return (
    <Link
      to={to}
      onClick={async (event) => {
        event.preventDefault()

        if (disabled) {
          return
        }

        if (beforeNavigate) {
          await beforeNavigate(event)
        }

        navigate(to, { replace })

        if (afterNavigate) {
          await afterNavigate(event)
        }
      }}
      className={cn({ 'opacity-75': disabled }, className)}
      {...props}
    />
  )
}

export default ActionLink
